module.exports = __webpack_public_path__ + "static/media/cancelled_cheque.92deb58e.svg";